// extracted by mini-css-extract-plugin
export default {"scrollBtn":"ScrollToTopButton-module--scrollBtn--51897","arrow":"ScrollToTopButton-module--arrow--10732","show":"ScrollToTopButton-module--show--4be07"};